import { create } from 'zustand';
import { StepId } from 'config/flow';
import { CatalogSize, Category, EcommercePlatform, SellingType, StoreType } from 'config/enums';
import { PersistentStore } from 'utils/persistent-store';

const appStorage = new PersistentStore<AppState>('stores-onboarding-app-state', {
  sellingTypes: [],
});

export type AppState = {
  currentStep?: StepId;
  storeType?: StoreType;
  sellingTypes: SellingType[];
  category?: Category;
  catalogSize?: CatalogSize;
  templateSlug?: string;
  siteName?: string;
  currentPlatformUrl?: string;
  currentPlatform?: EcommercePlatform;
  metaSiteId?: string;
};

type Store = AppState & {
  setCurrentStep: (currentStep: AppState['currentStep']) => void;
  setStoreType: (storeType: AppState['storeType']) => void;
  setSellingTypes: (sellingTypes: AppState['sellingTypes']) => void;
  setCategory: (category: AppState['category']) => void;
  setCatalogSize: (catalogSize: AppState['catalogSize']) => void;
  setTemplateSlug: (templateSlug: AppState['templateSlug']) => void;
  setSiteName: (siteName: AppState['siteName']) => void;
  setCurrentPlatformUrl: (currentPlatformUrl: AppState['currentPlatformUrl']) => void;
  setCurrentPlatform: (currentPlatform: AppState['currentPlatform']) => void;
  setMetaSiteId: (metaSiteId: AppState['metaSiteId']) => void;
};

const initialState: AppState = appStorage.getState();

export const useAppStore = create<Store>()((set) => ({
  ...initialState,
  setCurrentStep: (currentStep) => set({ currentStep }),
  setStoreType: (storeType) => set({ storeType }),
  setSellingTypes: (sellingTypes) => set({ sellingTypes }),
  setCategory: (category) => set({ category }),
  setCatalogSize: (catalogSize) => set({ catalogSize }),
  setTemplateSlug: (templateSlug) => set({ templateSlug }),
  setSiteName: (siteName) => set({ siteName }),
  setCurrentPlatformUrl: (currentPlatformUrl) => set({ currentPlatformUrl }),
  setCurrentPlatform: (currentPlatform) => set({ currentPlatform }),
  setMetaSiteId: (metaSiteId) => set({ metaSiteId }),
}));

useAppStore.subscribe((state) => {
  appStorage.setState(state);
});
